import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "node_hollow",
  "use": "node_hollow-usage",
  "viewBox": "0 0 22 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 12\" id=\"node_hollow\"><path d=\"M5 7H3v2h2V7zm14.97-7H2.03C.91 0 0 .91 0 2.03v7.94C0 11.09.91 12 2.03 12h17.94c1.12 0 2.03-.91 2.03-2.03V2.03C22 .91 21.09 0 19.97 0zM20 9.97c0 .02-.01.03-.03.03L2 9.97 2.03 2 20 2.03v7.94z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol